import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import Auth0 from './../../../../store/actions/auth/Auth';
import { CLEAR_RECIPIENTS_ERROR } from './reducer';

export const getRecipients = createAsyncThunk(
  'upload/getRecipients',
  async () => {
    const response = await axios.get('api/admin/Auth0User/getSellers', { 
      headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` } 
    });
    return response.data;
  }
);

export const clearRecipientsError = () => ({ type: CLEAR_RECIPIENTS_ERROR });

export const actionCreators = {
  getRecipients,
  clearRecipientsError

};